import { SelectOptionModel } from "../models/select-option.model";

export type StatusType = 'Pending' | 'Impeded' | 'Approved' | "Active" | "Inactive" | "Removed" | "Developing" | "Outdated" | "Replied"
  | "Late" | "Concluded" | "AwaitingSignature" | "Generated" | "Failed" | "InProcessing";

export enum enumStatus {
  "Pending" = 'Pending',
  "Impeded" = 'Impeded',
  "Approved" = 'Approved',
  "Active" = "Active",
  "Inactive" = "Inactive",
  "Removed" = "Removed",
  "Developing" = "Developing",
  "Outdated" = "Outdated",
  "Replied" = "Replied",
  "Late" = "Late",
  "Concluded" = "Concluded",
  "AwaitingSignature" = "AwaitingSignature",
  "Generated" = "Generated",
  "Failed" = "Failed",
  "InProcessing" = "InProcessing"
}

export enum enumStatusTranslated {
  "Pending" = 'Pendente',
  "Impeded" = 'Impedido',
  "Approved" = 'Aprovado',
  "Active" = "Ativo",
  "Inactive" = "Inativo",
  "Removed" = "Removido",
  "Developing" = "Em desenvolvimento",
  "Outdated" = "Desatualizado",
  "Replied" = "Respondido",
  "Late" = "Atrasado",
  "Concluded" = "Concluído",
  "AwaitingSignature" = "Aguardando Assinatura",
  "Generated" = "Gerado",
  "Failed" = "Falhou",
  "InProcessing" = "Em Processamento",
  "PartiallyCompleted" = "Concluído Parcialmente"
}

export enum enumInternshipImportStatusTranslated {
  "Importado com falha(s)" = "danger",
  "Importado com sucesso" = "success",
  "Não importado" = "default"
}

export enum enumStatusToBadge {
  "Active" = 'success',
  "Replied" = 'success',
  "Inactive" = 'default',
  "Removed" = 'danger',
  "Impeded" = 'danger',
  "Developing" = 'cnet-primary',
  "Outdated" = 'default',
  "Pending" = 'warning',
  "Late" = "danger",
  "Concluded" = "success",
  "AwaitingSignature" = "info",
  "Generated" = "info",
  "Failed" = 'danger',
  "InProcessing" = 'cnet-primary',
  "PartiallyCompleted" = "warning",
}

export enum enumBatchStatus {
  "PartiallyCompleted" = "Concluído Parcialmente",
  "Concluded" = "Concluído",
  "Failed" = "Falhou",
  "InProcessing" = "Em Processamento"
}

export function enumBatchStatusAsArray() {
  return Object.keys(enumBatchStatus).sort((a, b) => a.toLowerCase() < b.toLowerCase() ? -1 : 1).map(batchStatus => { return new SelectOptionModel<string>(enumBatchStatus[batchStatus], batchStatus) })
}
